// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from '@coa/app/shared/select-items-shared/store/compare-footer.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME);

export const selectIsLoading = createSelector(
  currentState,
  (state: State) => state.isLoading,
);

export const selectIsError = createSelector(
  currentState,
  (state: State) => state.isError,
);

export const selectNames = createSelector(
  currentState,
  (state: State) => state.compareNamesResponse,
);
